import rest, { getData } from 'util/Api';
import { API, haveDateLoaded } from 'default';
import { call, put, select, all, takeLatest } from 'redux-saga/effects';
import { actions } from './slice';
import { selectPackagesHistory } from './selectors';

const URL = API.packages.history;

function* fetchSaga() {
  try {
    const {
      pageable: { pageNumber, pageSize },
      search,
      status,
      type,
      date,
      marketplaceId,
    } = yield select(selectPackagesHistory);
    const searchParams = new URLSearchParams({
      page: pageNumber,
      size: pageSize,
      desc: true,
      packageType: type,
      search,
      status,
      from: date.from,
      to: date.to,
      marketplaceId,
    });
    const packages = yield call(getData, `${URL}?${searchParams.toString()}`);
    const items = packages.content;
    const total = packages.totalElements;
    yield put({
      type: actions.success.type,
      payload: {
        items,
        total,
      },
    });
  } catch (error) {
    yield put({ type: actions.failure.type });
  }
}

function* updateBasefilters() {
  const { status, date } = yield select(selectPackagesHistory);
  if (status === null || !haveDateLoaded(date)) {
    return;
  }
  yield put({
    type: actions.fetch.type,
  });
}

function* addPacketSagas({ payload }) {
  const { items } = yield select(selectPackagesHistory);
  const index = items.findIndex((packet) => packet.id === payload.id);
  if (index !== -1 && items[index].status === payload.status) {
    return;
  }
  yield call(updateBasefilters);
}

export const fetchPackagesForCsv = async (
  dispatch,
  search,
  marketplaceId,
  packageType,
  status,
  date,
) => {
  try {
    dispatch(actions.fetchForCsv());
    const searchParams = new URLSearchParams({
      search,
      marketplaceId,
      packageType,
      status,
      from: date.from,
      to: date.to,
      paquerView: false,
    });
    const response = await rest.get(
      `${API.reports.history}?${searchParams.toString()}`,
      {
        responseType: 'blob',
      },
    );
    dispatch(actions.fetchForCsvSuccess());
    return response.data;
  } catch (error) {
    dispatch(actions.fetchForCsvFailure());
    return null;
  }
};

export default function* rootSaga() {
  yield all([
    takeLatest(
      [
        actions.updatePagination,
        actions.updateSearch,
        actions.updatePackageType,
        actions.updateStatus,
        actions.refreshPage,
        actions.updateDate,
        actions.updateMarketplace,
      ],
      updateBasefilters,
    ),
    takeLatest(actions.updatePacket, addPacketSagas),
    takeLatest(actions.fetch, fetchSaga),
  ]);
}
